// GENERATED FILE. Do not edit manually. Run /root/web/shared/phone/sync-phone-metadata.js.

export const PHONE_COUNTRY_METADATA = [
  {
    "country": "South Africa",
    "iso2": "ZA",
    "flag": "🇿🇦",
    "dialCode": "+27"
  },
  {
    "country": "Afghanistan",
    "iso2": "AF",
    "flag": "🇦🇫",
    "dialCode": "+93"
  },
  {
    "country": "Albania",
    "iso2": "AL",
    "flag": "🇦🇱",
    "dialCode": "+355"
  },
  {
    "country": "Algeria",
    "iso2": "DZ",
    "flag": "🇩🇿",
    "dialCode": "+213"
  },
  {
    "country": "Andorra",
    "iso2": "AD",
    "flag": "🇦🇩",
    "dialCode": "+376"
  },
  {
    "country": "Angola",
    "iso2": "AO",
    "flag": "🇦🇴",
    "dialCode": "+244"
  },
  {
    "country": "Argentina",
    "iso2": "AR",
    "flag": "🇦🇷",
    "dialCode": "+54"
  },
  {
    "country": "Armenia",
    "iso2": "AM",
    "flag": "🇦🇲",
    "dialCode": "+374"
  },
  {
    "country": "Australia",
    "iso2": "AU",
    "flag": "🇦🇺",
    "dialCode": "+61"
  },
  {
    "country": "Austria",
    "iso2": "AT",
    "flag": "🇦🇹",
    "dialCode": "+43"
  },
  {
    "country": "Azerbaijan",
    "iso2": "AZ",
    "flag": "🇦🇿",
    "dialCode": "+994"
  },
  {
    "country": "Bahrain",
    "iso2": "BH",
    "flag": "🇧🇭",
    "dialCode": "+973"
  },
  {
    "country": "Bangladesh",
    "iso2": "BD",
    "flag": "🇧🇩",
    "dialCode": "+880"
  },
  {
    "country": "Belarus",
    "iso2": "BY",
    "flag": "🇧🇾",
    "dialCode": "+375"
  },
  {
    "country": "Belgium",
    "iso2": "BE",
    "flag": "🇧🇪",
    "dialCode": "+32"
  },
  {
    "country": "Belize",
    "iso2": "BZ",
    "flag": "🇧🇿",
    "dialCode": "+501"
  },
  {
    "country": "Benin",
    "iso2": "BJ",
    "flag": "🇧🇯",
    "dialCode": "+229"
  },
  {
    "country": "Bhutan",
    "iso2": "BT",
    "flag": "🇧🇹",
    "dialCode": "+975"
  },
  {
    "country": "Bolivia",
    "iso2": "BO",
    "flag": "🇧🇴",
    "dialCode": "+591"
  },
  {
    "country": "Bosnia and Herzegovina",
    "iso2": "BA",
    "flag": "🇧🇦",
    "dialCode": "+387"
  },
  {
    "country": "Botswana",
    "iso2": "BW",
    "flag": "🇧🇼",
    "dialCode": "+267"
  },
  {
    "country": "Brazil",
    "iso2": "BR",
    "flag": "🇧🇷",
    "dialCode": "+55"
  },
  {
    "country": "Brunei",
    "iso2": "BN",
    "flag": "🇧🇳",
    "dialCode": "+673"
  },
  {
    "country": "Bulgaria",
    "iso2": "BG",
    "flag": "🇧🇬",
    "dialCode": "+359"
  },
  {
    "country": "Burkina Faso",
    "iso2": "BF",
    "flag": "🇧🇫",
    "dialCode": "+226"
  },
  {
    "country": "Burundi",
    "iso2": "BI",
    "flag": "🇧🇮",
    "dialCode": "+257"
  },
  {
    "country": "Cambodia",
    "iso2": "KH",
    "flag": "🇰🇭",
    "dialCode": "+855"
  },
  {
    "country": "Cameroon",
    "iso2": "CM",
    "flag": "🇨🇲",
    "dialCode": "+237"
  },
  {
    "country": "Canada",
    "iso2": "CA",
    "flag": "🇨🇦",
    "dialCode": "+1"
  },
  {
    "country": "Cape Verde",
    "iso2": "CV",
    "flag": "🇨🇻",
    "dialCode": "+238"
  },
  {
    "country": "Central African Republic",
    "iso2": "CF",
    "flag": "🇨🇫",
    "dialCode": "+236"
  },
  {
    "country": "Chad",
    "iso2": "TD",
    "flag": "🇹🇩",
    "dialCode": "+235"
  },
  {
    "country": "Chile",
    "iso2": "CL",
    "flag": "🇨🇱",
    "dialCode": "+56"
  },
  {
    "country": "China",
    "iso2": "CN",
    "flag": "🇨🇳",
    "dialCode": "+86"
  },
  {
    "country": "Colombia",
    "iso2": "CO",
    "flag": "🇨🇴",
    "dialCode": "+57"
  },
  {
    "country": "Comoros",
    "iso2": "KM",
    "flag": "🇰🇲",
    "dialCode": "+269"
  },
  {
    "country": "Congo",
    "iso2": "CG",
    "flag": "🇨🇬",
    "dialCode": "+242"
  },
  {
    "country": "Costa Rica",
    "iso2": "CR",
    "flag": "🇨🇷",
    "dialCode": "+506"
  },
  {
    "country": "Croatia",
    "iso2": "HR",
    "flag": "🇭🇷",
    "dialCode": "+385"
  },
  {
    "country": "Cuba",
    "iso2": "CU",
    "flag": "🇨🇺",
    "dialCode": "+53"
  },
  {
    "country": "Cyprus",
    "iso2": "CY",
    "flag": "🇨🇾",
    "dialCode": "+357"
  },
  {
    "country": "Czech Republic",
    "iso2": "CZ",
    "flag": "🇨🇿",
    "dialCode": "+420"
  },
  {
    "country": "Denmark",
    "iso2": "DK",
    "flag": "🇩🇰",
    "dialCode": "+45"
  },
  {
    "country": "Djibouti",
    "iso2": "DJ",
    "flag": "🇩🇯",
    "dialCode": "+253"
  },
  {
    "country": "Dominican Republic",
    "iso2": "DO",
    "flag": "🇩🇴",
    "dialCode": "+1"
  },
  {
    "country": "DR Congo",
    "iso2": "CD",
    "flag": "🇨🇩",
    "dialCode": "+243"
  },
  {
    "country": "Ecuador",
    "iso2": "EC",
    "flag": "🇪🇨",
    "dialCode": "+593"
  },
  {
    "country": "Egypt",
    "iso2": "EG",
    "flag": "🇪🇬",
    "dialCode": "+20"
  },
  {
    "country": "El Salvador",
    "iso2": "SV",
    "flag": "🇸🇻",
    "dialCode": "+503"
  },
  {
    "country": "Equatorial Guinea",
    "iso2": "GQ",
    "flag": "🇬🇶",
    "dialCode": "+240"
  },
  {
    "country": "Eritrea",
    "iso2": "ER",
    "flag": "🇪🇷",
    "dialCode": "+291"
  },
  {
    "country": "Estonia",
    "iso2": "EE",
    "flag": "🇪🇪",
    "dialCode": "+372"
  },
  {
    "country": "Eswatini",
    "iso2": "SZ",
    "flag": "🇸🇿",
    "dialCode": "+268"
  },
  {
    "country": "Ethiopia",
    "iso2": "ET",
    "flag": "🇪🇹",
    "dialCode": "+251"
  },
  {
    "country": "Finland",
    "iso2": "FI",
    "flag": "🇫🇮",
    "dialCode": "+358"
  },
  {
    "country": "France",
    "iso2": "FR",
    "flag": "🇫🇷",
    "dialCode": "+33"
  },
  {
    "country": "Gabon",
    "iso2": "GA",
    "flag": "🇬🇦",
    "dialCode": "+241"
  },
  {
    "country": "Gambia",
    "iso2": "GM",
    "flag": "🇬🇲",
    "dialCode": "+220"
  },
  {
    "country": "Georgia",
    "iso2": "GE",
    "flag": "🇬🇪",
    "dialCode": "+995"
  },
  {
    "country": "Germany",
    "iso2": "DE",
    "flag": "🇩🇪",
    "dialCode": "+49"
  },
  {
    "country": "Ghana",
    "iso2": "GH",
    "flag": "🇬🇭",
    "dialCode": "+233"
  },
  {
    "country": "Greece",
    "iso2": "GR",
    "flag": "🇬🇷",
    "dialCode": "+30"
  },
  {
    "country": "Guatemala",
    "iso2": "GT",
    "flag": "🇬🇹",
    "dialCode": "+502"
  },
  {
    "country": "Guinea",
    "iso2": "GN",
    "flag": "🇬🇳",
    "dialCode": "+224"
  },
  {
    "country": "Guyana",
    "iso2": "GY",
    "flag": "🇬🇾",
    "dialCode": "+592"
  },
  {
    "country": "Haiti",
    "iso2": "HT",
    "flag": "🇭🇹",
    "dialCode": "+509"
  },
  {
    "country": "Honduras",
    "iso2": "HN",
    "flag": "🇭🇳",
    "dialCode": "+504"
  },
  {
    "country": "Hungary",
    "iso2": "HU",
    "flag": "🇭🇺",
    "dialCode": "+36"
  },
  {
    "country": "Iceland",
    "iso2": "IS",
    "flag": "🇮🇸",
    "dialCode": "+354"
  },
  {
    "country": "India",
    "iso2": "IN",
    "flag": "🇮🇳",
    "dialCode": "+91"
  },
  {
    "country": "Indonesia",
    "iso2": "ID",
    "flag": "🇮🇩",
    "dialCode": "+62"
  },
  {
    "country": "Iran",
    "iso2": "IR",
    "flag": "🇮🇷",
    "dialCode": "+98"
  },
  {
    "country": "Iraq",
    "iso2": "IQ",
    "flag": "🇮🇶",
    "dialCode": "+964"
  },
  {
    "country": "Ireland",
    "iso2": "IE",
    "flag": "🇮🇪",
    "dialCode": "+353"
  },
  {
    "country": "Israel",
    "iso2": "IL",
    "flag": "🇮🇱",
    "dialCode": "+972"
  },
  {
    "country": "Italy",
    "iso2": "IT",
    "flag": "🇮🇹",
    "dialCode": "+39"
  },
  {
    "country": "Ivory Coast",
    "iso2": "CI",
    "flag": "🇨🇮",
    "dialCode": "+225"
  },
  {
    "country": "Jamaica",
    "iso2": "JM",
    "flag": "🇯🇲",
    "dialCode": "+1"
  },
  {
    "country": "Japan",
    "iso2": "JP",
    "flag": "🇯🇵",
    "dialCode": "+81"
  },
  {
    "country": "Jordan",
    "iso2": "JO",
    "flag": "🇯🇴",
    "dialCode": "+962"
  },
  {
    "country": "Kazakhstan",
    "iso2": "KZ",
    "flag": "🇰🇿",
    "dialCode": "+7"
  },
  {
    "country": "Kenya",
    "iso2": "KE",
    "flag": "🇰🇪",
    "dialCode": "+254"
  },
  {
    "country": "Kuwait",
    "iso2": "KW",
    "flag": "🇰🇼",
    "dialCode": "+965"
  },
  {
    "country": "Kyrgyzstan",
    "iso2": "KG",
    "flag": "🇰🇬",
    "dialCode": "+996"
  },
  {
    "country": "Laos",
    "iso2": "LA",
    "flag": "🇱🇦",
    "dialCode": "+856"
  },
  {
    "country": "Latvia",
    "iso2": "LV",
    "flag": "🇱🇻",
    "dialCode": "+371"
  },
  {
    "country": "Lebanon",
    "iso2": "LB",
    "flag": "🇱🇧",
    "dialCode": "+961"
  },
  {
    "country": "Lesotho",
    "iso2": "LS",
    "flag": "🇱🇸",
    "dialCode": "+266"
  },
  {
    "country": "Liberia",
    "iso2": "LR",
    "flag": "🇱🇷",
    "dialCode": "+231"
  },
  {
    "country": "Libya",
    "iso2": "LY",
    "flag": "🇱🇾",
    "dialCode": "+218"
  },
  {
    "country": "Lithuania",
    "iso2": "LT",
    "flag": "🇱🇹",
    "dialCode": "+370"
  },
  {
    "country": "Luxembourg",
    "iso2": "LU",
    "flag": "🇱🇺",
    "dialCode": "+352"
  },
  {
    "country": "Madagascar",
    "iso2": "MG",
    "flag": "🇲🇬",
    "dialCode": "+261"
  },
  {
    "country": "Malawi",
    "iso2": "MW",
    "flag": "🇲🇼",
    "dialCode": "+265"
  },
  {
    "country": "Malaysia",
    "iso2": "MY",
    "flag": "🇲🇾",
    "dialCode": "+60"
  },
  {
    "country": "Mali",
    "iso2": "ML",
    "flag": "🇲🇱",
    "dialCode": "+223"
  },
  {
    "country": "Malta",
    "iso2": "MT",
    "flag": "🇲🇹",
    "dialCode": "+356"
  },
  {
    "country": "Mauritania",
    "iso2": "MR",
    "flag": "🇲🇷",
    "dialCode": "+222"
  },
  {
    "country": "Mauritius",
    "iso2": "MU",
    "flag": "🇲🇺",
    "dialCode": "+230"
  },
  {
    "country": "Mexico",
    "iso2": "MX",
    "flag": "🇲🇽",
    "dialCode": "+52"
  },
  {
    "country": "Moldova",
    "iso2": "MD",
    "flag": "🇲🇩",
    "dialCode": "+373"
  },
  {
    "country": "Mongolia",
    "iso2": "MN",
    "flag": "🇲🇳",
    "dialCode": "+976"
  },
  {
    "country": "Montenegro",
    "iso2": "ME",
    "flag": "🇲🇪",
    "dialCode": "+382"
  },
  {
    "country": "Morocco",
    "iso2": "MA",
    "flag": "🇲🇦",
    "dialCode": "+212"
  },
  {
    "country": "Mozambique",
    "iso2": "MZ",
    "flag": "🇲🇿",
    "dialCode": "+258"
  },
  {
    "country": "Myanmar",
    "iso2": "MM",
    "flag": "🇲🇲",
    "dialCode": "+95"
  },
  {
    "country": "Namibia",
    "iso2": "NA",
    "flag": "🇳🇦",
    "dialCode": "+264"
  },
  {
    "country": "Nepal",
    "iso2": "NP",
    "flag": "🇳🇵",
    "dialCode": "+977"
  },
  {
    "country": "Netherlands",
    "iso2": "NL",
    "flag": "🇳🇱",
    "dialCode": "+31"
  },
  {
    "country": "New Zealand",
    "iso2": "NZ",
    "flag": "🇳🇿",
    "dialCode": "+64"
  },
  {
    "country": "Nicaragua",
    "iso2": "NI",
    "flag": "🇳🇮",
    "dialCode": "+505"
  },
  {
    "country": "Niger",
    "iso2": "NE",
    "flag": "🇳🇪",
    "dialCode": "+227"
  },
  {
    "country": "Nigeria",
    "iso2": "NG",
    "flag": "🇳🇬",
    "dialCode": "+234"
  },
  {
    "country": "North Macedonia",
    "iso2": "MK",
    "flag": "🇲🇰",
    "dialCode": "+389"
  },
  {
    "country": "Norway",
    "iso2": "NO",
    "flag": "🇳🇴",
    "dialCode": "+47"
  },
  {
    "country": "Oman",
    "iso2": "OM",
    "flag": "🇴🇲",
    "dialCode": "+968"
  },
  {
    "country": "Pakistan",
    "iso2": "PK",
    "flag": "🇵🇰",
    "dialCode": "+92"
  },
  {
    "country": "Panama",
    "iso2": "PA",
    "flag": "🇵🇦",
    "dialCode": "+507"
  },
  {
    "country": "Papua New Guinea",
    "iso2": "PG",
    "flag": "🇵🇬",
    "dialCode": "+675"
  },
  {
    "country": "Paraguay",
    "iso2": "PY",
    "flag": "🇵🇾",
    "dialCode": "+595"
  },
  {
    "country": "Peru",
    "iso2": "PE",
    "flag": "🇵🇪",
    "dialCode": "+51"
  },
  {
    "country": "Philippines",
    "iso2": "PH",
    "flag": "🇵🇭",
    "dialCode": "+63"
  },
  {
    "country": "Poland",
    "iso2": "PL",
    "flag": "🇵🇱",
    "dialCode": "+48"
  },
  {
    "country": "Portugal",
    "iso2": "PT",
    "flag": "🇵🇹",
    "dialCode": "+351"
  },
  {
    "country": "Qatar",
    "iso2": "QA",
    "flag": "🇶🇦",
    "dialCode": "+974"
  },
  {
    "country": "Romania",
    "iso2": "RO",
    "flag": "🇷🇴",
    "dialCode": "+40"
  },
  {
    "country": "Russia",
    "iso2": "RU",
    "flag": "🇷🇺",
    "dialCode": "+7"
  },
  {
    "country": "Rwanda",
    "iso2": "RW",
    "flag": "🇷🇼",
    "dialCode": "+250"
  },
  {
    "country": "Saudi Arabia",
    "iso2": "SA",
    "flag": "🇸🇦",
    "dialCode": "+966"
  },
  {
    "country": "Senegal",
    "iso2": "SN",
    "flag": "🇸🇳",
    "dialCode": "+221"
  },
  {
    "country": "Serbia",
    "iso2": "RS",
    "flag": "🇷🇸",
    "dialCode": "+381"
  },
  {
    "country": "Sierra Leone",
    "iso2": "SL",
    "flag": "🇸🇱",
    "dialCode": "+232"
  },
  {
    "country": "Singapore",
    "iso2": "SG",
    "flag": "🇸🇬",
    "dialCode": "+65"
  },
  {
    "country": "Slovakia",
    "iso2": "SK",
    "flag": "🇸🇰",
    "dialCode": "+421"
  },
  {
    "country": "Slovenia",
    "iso2": "SI",
    "flag": "🇸🇮",
    "dialCode": "+386"
  },
  {
    "country": "Somalia",
    "iso2": "SO",
    "flag": "🇸🇴",
    "dialCode": "+252"
  },
  {
    "country": "South Korea",
    "iso2": "KR",
    "flag": "🇰🇷",
    "dialCode": "+82"
  },
  {
    "country": "South Sudan",
    "iso2": "SS",
    "flag": "🇸🇸",
    "dialCode": "+211"
  },
  {
    "country": "Spain",
    "iso2": "ES",
    "flag": "🇪🇸",
    "dialCode": "+34"
  },
  {
    "country": "Sri Lanka",
    "iso2": "LK",
    "flag": "🇱🇰",
    "dialCode": "+94"
  },
  {
    "country": "Sudan",
    "iso2": "SD",
    "flag": "🇸🇩",
    "dialCode": "+249"
  },
  {
    "country": "Suriname",
    "iso2": "SR",
    "flag": "🇸🇷",
    "dialCode": "+597"
  },
  {
    "country": "Sweden",
    "iso2": "SE",
    "flag": "🇸🇪",
    "dialCode": "+46"
  },
  {
    "country": "Switzerland",
    "iso2": "CH",
    "flag": "🇨🇭",
    "dialCode": "+41"
  },
  {
    "country": "Syria",
    "iso2": "SY",
    "flag": "🇸🇾",
    "dialCode": "+963"
  },
  {
    "country": "Taiwan",
    "iso2": "TW",
    "flag": "🇹🇼",
    "dialCode": "+886"
  },
  {
    "country": "Tajikistan",
    "iso2": "TJ",
    "flag": "🇹🇯",
    "dialCode": "+992"
  },
  {
    "country": "Tanzania",
    "iso2": "TZ",
    "flag": "🇹🇿",
    "dialCode": "+255"
  },
  {
    "country": "Thailand",
    "iso2": "TH",
    "flag": "🇹🇭",
    "dialCode": "+66"
  },
  {
    "country": "Togo",
    "iso2": "TG",
    "flag": "🇹🇬",
    "dialCode": "+228"
  },
  {
    "country": "Trinidad and Tobago",
    "iso2": "TT",
    "flag": "🇹🇹",
    "dialCode": "+1"
  },
  {
    "country": "Tunisia",
    "iso2": "TN",
    "flag": "🇹🇳",
    "dialCode": "+216"
  },
  {
    "country": "Turkey",
    "iso2": "TR",
    "flag": "🇹🇷",
    "dialCode": "+90"
  },
  {
    "country": "Turkmenistan",
    "iso2": "TM",
    "flag": "🇹🇲",
    "dialCode": "+993"
  },
  {
    "country": "Uganda",
    "iso2": "UG",
    "flag": "🇺🇬",
    "dialCode": "+256"
  },
  {
    "country": "Ukraine",
    "iso2": "UA",
    "flag": "🇺🇦",
    "dialCode": "+380"
  },
  {
    "country": "United Arab Emirates",
    "iso2": "AE",
    "flag": "🇦🇪",
    "dialCode": "+971"
  },
  {
    "country": "United Kingdom",
    "iso2": "GB",
    "flag": "🇬🇧",
    "dialCode": "+44"
  },
  {
    "country": "United States",
    "iso2": "US",
    "flag": "🇺🇸",
    "dialCode": "+1"
  },
  {
    "country": "Uruguay",
    "iso2": "UY",
    "flag": "🇺🇾",
    "dialCode": "+598"
  },
  {
    "country": "Uzbekistan",
    "iso2": "UZ",
    "flag": "🇺🇿",
    "dialCode": "+998"
  },
  {
    "country": "Venezuela",
    "iso2": "VE",
    "flag": "🇻🇪",
    "dialCode": "+58"
  },
  {
    "country": "Vietnam",
    "iso2": "VN",
    "flag": "🇻🇳",
    "dialCode": "+84"
  },
  {
    "country": "Yemen",
    "iso2": "YE",
    "flag": "🇾🇪",
    "dialCode": "+967"
  },
  {
    "country": "Zambia",
    "iso2": "ZM",
    "flag": "🇿🇲",
    "dialCode": "+260"
  },
  {
    "country": "Zimbabwe",
    "iso2": "ZW",
    "flag": "🇿🇼",
    "dialCode": "+263"
  }
];

export const COUNTRY_OPTIONS = PHONE_COUNTRY_METADATA.map((entry) => entry.country);

export const PHONE_CODE_BY_COUNTRY = PHONE_COUNTRY_METADATA.reduce((acc, entry) => {
  acc[entry.country] = entry.dialCode;
  return acc;
}, {});

export const PHONE_CODE_OPTIONS = Array.from(new Set(PHONE_COUNTRY_METADATA.map((entry) => entry.dialCode)))
  .sort((a, b) => Number(a.replace(/\D/g, '')) - Number(b.replace(/\D/g, '')));

export const PHONE_CODE_SEARCH_OPTIONS = PHONE_COUNTRY_METADATA
  .map((entry) => ({
    label: `${entry.flag} ${entry.dialCode} ${entry.country}`,
    value: entry.dialCode,
    country: entry.country,
    iso2: entry.iso2,
    flag: entry.flag,
    dialCode: entry.dialCode,
    searchText: `${entry.country} ${entry.iso2} ${entry.dialCode}`,
  }))
  .sort((a, b) => a.country.localeCompare(b.country));

export const getDefaultPhoneCodeForCountry = (country, fallback = '+27') =>
  PHONE_CODE_BY_COUNTRY[String(country || '').trim()] || fallback;

export const normalizePhoneCountryCode = (value) => {
  const digits = String(value || '').replace(/[^\d]/g, '');
  return digits ? `+${digits}` : '';
};

export const normalizePhoneNationalNumber = (value) => String(value || '').replace(/[^\d]/g, '');

export const combinePhoneValue = (countryCode, nationalNumber) => {
  const code = normalizePhoneCountryCode(countryCode);
  const local = normalizePhoneNationalNumber(nationalNumber).replace(/^0+/, '');
  return code && local ? `${code}${local}` : '';
};

export const splitPhoneValue = (phone, country = 'South Africa') => {
  const fallbackCode = getDefaultPhoneCodeForCountry(country);
  const value = String(phone || '').trim().replace(/[^\d+]/g, '');
  if (!value) return { phoneCountryCode: fallbackCode, phoneNationalNumber: '' };
  if (!value.startsWith('+')) {
    const digits = value.replace(/[^\d]/g, '');
    const fallbackDigits = fallbackCode.replace(/[^\d]/g, '');
    const national = fallbackDigits && digits.startsWith(fallbackDigits) && digits.length > fallbackDigits.length
      ? digits.slice(fallbackDigits.length)
      : digits;
    return { phoneCountryCode: fallbackCode, phoneNationalNumber: national.replace(/^0+/, '') };
  }
  const knownCode = PHONE_CODE_OPTIONS
    .slice()
    .sort((a, b) => b.length - a.length)
    .find((entry) => value.startsWith(entry));
  if (knownCode) {
    return {
      phoneCountryCode: knownCode,
      phoneNationalNumber: value.slice(knownCode.length).replace(/^0+/, ''),
    };
  }
  const inferred = value.match(/^\+\d{1,4}/)?.[0] || fallbackCode;
  return { phoneCountryCode: inferred, phoneNationalNumber: value.slice(inferred.length).replace(/^0+/, '') };
};
